import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function DevisConstructionAtelierProduction({
  variablesData,
}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Vous trouverez ci-joint le détail des coûts que nous vous soumettons
        pour la construction d'un atelier supplémentaire attenant à votre usine.
      </p>
      <p>
        J'espère que cette soumission correspondra à vos attentes et n'hésitez
        pas à nous contacter en cas de besoin.
      </p>
      <p>
        La date de livraison est prévue le{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.livraison_atelier_production_date_prevue) || 0,
        )}
      </p>
      <p>
        Veuillez agréer, {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom}, l'expression de nos
        sentiments respectueux.
      </p>
      <MailSignature
        emetteurLogo={DevisConstructionAtelierProduction.metadata.emetteurLogo}
        emetteur={DevisConstructionAtelierProduction.metadata.emetteur}
        emetteurPoste={
          DevisConstructionAtelierProduction.metadata.emetteurPoste
        }
        emetteurEntreprise={
          DevisConstructionAtelierProduction.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

DevisConstructionAtelierProduction.metadata = {
  titre: "Devis construction atelier de production",
  cleMail: "devis_construction_atelier_production",
  messageTransfert: false,
  emetteur: "Roger COEUR",
  emetteurPoste: "Gérant",
  emetteurEntreprise: "LECCO Construction",
  emetteurLogo: "/logos/lecco.png",
  dateRelative: -60,
  piecesJointes: ["devis-lecco-construction"],
} as MailMetadata;

export default DevisConstructionAtelierProduction;
